import { useState, useEffect } from "react";
import { Listbox } from "@headlessui/react";
import {
  ChevronDownIcon,
  MinusIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";

// const tokens = ["BTC/USDT", "ETH/USDT", "XRP/USDT", "SOL/USDT", "SHIB/USDT"];

export default function TokenPercentageSelector({
  token,
  percent,
  onChange,
  onTokenChange,
  options,
}) {
  const [selectedToken, setSelectedToken] = useState(token);
  const [percentage, setPercentage] = useState(percent);
  const [isFocused, setIsFocused] = useState(false);

  // Notify parent on value changes
  useEffect(() => {
    onChange?.(percentage);
  }, [percentage]);

  useEffect(() => {
    onTokenChange?.(selectedToken);
  }, [selectedToken]);

  useEffect(() => {
    setSelectedToken(token);
  }, [token]);

  useEffect(() => {
    setPercentage(percent);
  }, [percent]);

  const decrease = () => setPercentage((p) => Math.max(0, p - 1));
  const increase = () => setPercentage((p) => Math.min(100, p + 1));

  const handleInputChange = (e) => {
    const val = Number(e.target.value);
    if (
      (val === "" || (/^\d{1,3}$/.test(val) && Number(val) <= 100)) &&
      !isNaN(val) &&
      val >= 0 &&
      val <= 100
    ) {
      setPercentage(val);
    }
  };

  const displayValue = isFocused
    ? percentage
    : percentage !== ""
    ? `${percentage}%`
    : "";

  return (
    <div className="flex items-center gap-4 w-full">
      {/* Token Dropdown */}
      <Listbox value={selectedToken} onChange={setSelectedToken}>
        <div className="relative w-full">
          <Listbox.Button className="flex items-center justify-between w-full px-4 py-3 rounded-xl bg-gray-100 text-black font-semibold">
            <div className="text-center w-full">{selectedToken}</div>
            <ChevronDownIcon className="w-4 h-4 ml-2 text-gray-500" />
          </Listbox.Button>
          <Listbox.Options className="absolute mt-1 w-full rounded-md bg-white shadow-lg z-10 max-h-[10rem] overflow-y-auto">
            {options.map((opt, idx) => (
              <Listbox.Option
                key={idx}
                value={opt.pair}
                className={({ active }) =>
                  `cursor-pointer px-4 py-2 ${
                    active ? "bg-gray-200" : "bg-white"
                  }`
                }
              >
                {opt.pair}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </div>
      </Listbox>

      {/* Percentage Control */}
      <div className="flex items-center gap-2 w-full px-4 py-3 rounded-xl bg-gray-100">
        <button onClick={decrease} className="bg-transparent p-0">
          <MinusIcon className="w-4 h-4 text-gray-700" />
        </button>
        <input
          type="text"
          value={displayValue}
          min={0}
          max={100}
          onChange={handleInputChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className="w-fit text-center bg-transparent border-none focus:!outline-none rounded px-2 py-1 text-sm"
        />
        <button onClick={increase} className="bg-transparent p-0">
          <PlusIcon className="w-4 h-4 text-gray-700" />
        </button>
      </div>
    </div>
  );
}
